import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { taskKeys, RequestTypes } from '@core/react-query/features/tasks/task'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useTaskPdfDownloadUrl = (
  options?: UseMutationOptions<
    { urlGET: string; urlDownload: string; expiryInMinutes: number },
    RequestErrorType,
    RequestTypes['getPdfDownloadUrl']
  >,
) => {
  return useMutation({
    ...taskKeys.pdfDownloadUrl,
    ...options,
  })
}
